import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { isTelegram, getTelegramUser, expandApp, DEV_TELEGRAM_ID } from '../../utils/telegram';
import api from '../../utils/api';
import { AccessSnapshot } from '../../components/PortalAccess';

export default function AppGuard() {
  const navigate = useNavigate();
  const [userAccess, setUserAccess] = useState(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    expandApp();

    const inTelegram = isTelegram();
    const devMode = process.env.REACT_APP_DEV_MODE === 'true';

    if (!inTelegram && !devMode) {
      setStatus('not_telegram');
      return;
    }

    if (devMode && !inTelegram) {
      localStorage.setItem('dev_telegram_id', DEV_TELEGRAM_ID);
    }

    let active = true;
    const loadUser = () => api.get('/api/app/me')
      .then(async res => {
        if (!active) return;
        const user = res.data;
        if (user.role === 'admin') {
          try {
            const loginRes = await api.post('/api/auth/tg-login');
            localStorage.setItem('admin_token', loginRes.data.access_token);
          } catch {}
          window.location.replace('/admin');
          return;
        }
        if (user.status === 'pending') { setStatus('pending'); return; }
        if (user.status === 'rejected') { setStatus('rejected'); return; }
        setUserAccess({ permissions: user.permissions || {}, is_owner: false });
        setStatus('ok');
      })
      .catch(err => {
        if (!active) return;
        if (err.response?.status === 404) {
          navigate('/app/register');
        } else {
          setStatus('error');
        }
      });
    void loadUser();
    const timer = setInterval(loadUser, 30000);
    window.addEventListener('focus', loadUser);
    return () => { active = false; clearInterval(timer); window.removeEventListener('focus', loadUser); };
  }, [navigate]);

  if (status === 'loading') return <div className="app-loader"><div className="spinner" /><p>Загрузка...</p></div>;

  if (status === 'not_telegram') return (
    <div className="app-page centered">
      <div className="tg-only-icon">📱</div>
      <h2>Только в Telegram</h2>
      <p>Этот раздел доступен только через Telegram Mini App</p>
    </div>
  );

  if (status === 'pending') return (
    <div className="app-page centered">
      <div className="tg-only-icon">⏳</div>
      <h2>Заявка на рассмотрении</h2>
      <p>Ваша регистрация отправлена администратору. Ожидайте подтверждения.</p>
      <button type="button" className="btn-primary" onClick={() => window.location.reload()}>
        Проверить статус
      </button>
    </div>
  );

  if (status === 'rejected') return (
    <div className="app-page centered">
      <div className="tg-only-icon">❌</div>
      <h2>Регистрация отклонена</h2>
      <p>Обратитесь к администратору для уточнения.</p>
    </div>
  );

  if (status === 'error') return (
    <div className="app-page centered">
      <div className="tg-only-icon">⚠️</div>
      <h2>Ошибка подключения</h2>
      <p>Не удалось подключиться к серверу. Попробуйте позже.</p>
      <button type="button" className="btn-primary" onClick={() => window.location.reload()}>
        Повторить
      </button>
    </div>
  );

  return <AccessSnapshot value={userAccess}><Outlet /></AccessSnapshot>;
}
